document.addEventListener("input", function(e) {
  if (e.target.type === "tel" || e.target.name.includes("phone")) {

    let value = e.target.value;

    // only numbers
    value = value.replace(/\D/g, "");

    // remove +91 if user enters
    if(value.startsWith("91") && value.length > 10){
      value = value.substring(2);
    }

    e.target.value = value;

    if(value.length > 10){
      e.target.value = value.substring(0,10);
    }
  }
});


document.addEventListener("submit", function(e){

  let phone = document.querySelector('input[type="tel"]');

  if(phone){

    let number = phone.value.replace(/\D/g,'');

    if(number.length !== 10){

      e.preventDefault();

      alert("Please enter valid 10 digit mobile number");

      return false;
    }
  }

});